import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _WorkActivityGroup } from '../../../core/services/dataBean/EntityCatalog';

type FilterProps = {
    
}
interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    filter?: FilterProps;
}

export const SelectWorkActivityGroup = ({ idSelector, onChange, label, returnType = "ID", filter }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityGroup);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDWorkActivityGroup === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDWorkActivityGroup,
                    label: found.DataBeanProperties.GroupName,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        const props = {
            State: 1,
            ...(filter ?? {})
        };
        instance.getWorkActivityGroupCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDWorkActivityGroup,
        label: item.DataBeanProperties.GroupName,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Grupos de Trabajo Disponibles"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Grupo de Trabajo..."
                noOptionsMessage={() => "Sin coincidencias"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 1100 })
                }}
            />
        </div >
    );
};
